/**
 * Gets the correct stylesheet name
 * @param isDarkMode If the user prefers dark mode (system settings)
 * @param isNewInterface If the new interface feature is enabled
 */
export const getStylesheetName = (isDarkMode: boolean, isNewInterface: boolean) => {
	if (isNewInterface) {
		return isDarkMode ? "css/dark-new.min.css" : "css/light-new.min.css"
	}
	return isDarkMode ? "css/dark.min.css" : "css/light.min.css"
}

/**
 * Checks to see if a given stylesheet is a new or old theme.
 * @param stylesheet The stylsheet URL to check.
 * @returns True or false.
 */
export const isNewStyle = (stylesheet: string) => {
	return stylesheet.toLowerCase().endsWith("-new.min.css")
}
